import React from 'react';
import { Outlet } from 'react-router-dom';
import Card from 'components/Card';
import Steps from 'modules/Security/components/Steps';
import './style.scss';

const LinkAccount: React.FC = () => {
    return (
        <Card form>
            <h2>{__('Retrieve the Initial Password For Client Portal')}</h2>
            <div className="link-account-root">
                <Steps type="linkAccount" />
                <Outlet />
            </div>
        </Card>
    );
};

export default LinkAccount;
